var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Comments',{attrs:{"gongxu":"xu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }